(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({"/root/app-home/node_modules/module-tsl-ui-components/plugins/carousel-bullets/carousel-bullets-nojq.js":[function(require,module,exports){
var Swipe = require('swipe-js');

function swipe(selector, params) {
  params = params || {};
  var carouselNodes = document.querySelectorAll('.js-carousel-bullets');
  for (var i = 0; i < carouselNodes.length; i++) {
    new Swipe(carouselNodes[i], {
      auto: params.auto || 0,
      autoRestart: false,
      bulletWrapperClass: 'js-carousel-bullets-nav',
      bulletClass: 'carousel-bullets__nav-bullet',
    });
  }
}

module.exports = swipe;

},{"swipe-js":"/root/app-home/node_modules/swipe-js/swipe.js"}],"/root/app-home/node_modules/swipe-js/swipe.js":[function(require,module,exports){
/*
 * Swipe 2.0
 *
 * Brad Birdsall and Xiuyu Li
 * Copyright 2015, MIT License
 *
 */

function Swipe(container, options) {

  "use strict";

  // utilities
  var noop = function() {}; // simple no operation function
  var offloadFn = function(fn) { setTimeout(fn || noop, 0) }; // offload a functions execution

  // check browser capabilities
  var browser = {
    addEventListener: !!window.addEventListener,
    touch: ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch,
    transitions: (function(temp) {
      var props = ['transitionProperty', 'WebkitTransition', 'MozTransition', 'OTransition', 'msTransition'];
      for ( var i in props ) if (temp.style[ props[i] ] !== undefined) return true;
      return false;
    })(document.createElement('swipe'))
  };

  // quit if no root element
  if (!container) return;
  var element = container.children[0];
  var slides, slidePos, width, length;
  options = options || {};
  options.bulletWrapperClass = options.bulletWrapperClass ? '.' + options.bulletWrapperClass : '';
  var bulletWrapper = options.bulletWrapperClass || null;
  var bulletClass = options.bulletClass || 'swipe-bullet';
  var activeBulletClass = options.bulletActiveClass || 'active';
  var index = parseInt(options.startSlide, 10) || 0;
  var position = index;
  var clonedSlides = false;
  var speed = options.speed || 300;
  options.continuous = options.continuous !== undefined ? options.continuous : true;

  // AutoRestart option: auto restart slideshow after user's touch event
  options.autoRestart = options.autoRestart !== undefined ? options.autoRestart : true;

  //add a css class to a dom element
  function addClassToElem(elem,value){
    var rspaces = /\s+/;
    var classNames = (value || "").split( rspaces );
    var className = " " + elem.className + " ",
      setClass = elem.className;
    for ( var c = 0, cl = classNames.length; c < cl; c++ ) {

      if ( className.indexOf( " " + classNames[c] + " " ) < 0 ) {
        setClass += " " + classNames[c];
      }

    }
    elem.className = setClass.replace(/^\s+|\s+$/g,''); //trim
  }

  //remove a css class from a dom element
  function removeClassFromElem(elem,value){
    var rspaces = /\s+/;
    var rclass = /[\n\t]/g
    var classNames = (value || "").split( rspaces );
    var className = (" " + elem.className + " ").replace(rclass, " ");

    for ( var c = 0, cl = classNames.length; c < cl; c++ ) {
      className = className.replace(" " + classNames[c] + " ", " ");
    }

    elem.className = className.replace(/^\s+|\s+$/g,''); //trim
  }


  function addEventHandler(elem,eventType,handler) {
    if (elem.addEventListener)
      elem.addEventListener (eventType,handler,false);
    else if (elem.attachEvent)
      elem.attachEvent ('on'+eventType,handler);
  }

  // get the target of a click event, we need this so we have support for multiple browsers
  function getTarget(e) {
    var clickTarget;
    if (e.target) clickTarget = e.target;
    else if (e.srcElement) clickTarget = e.srcElement;
    if (clickTarget.nodeType == 3) // defeat Safari bug
      clickTarget = clickTarget.parentNode;

    return clickTarget;
  }

  function setup() {

    // cache slides
    slides = element.children;
    length = slides.length;

    // set continuous to false if only one slide
    if (slides.length < 2) options.continuous = false;

    //special case if two slides
    if (browser.transitions && options.continuous && slides.length < 3) {
      element.appendChild(slides[0].cloneNode(true));
      element.appendChild(element.children[1].cloneNode(true));
      slides = element.children;
      clonedSlides = true;
    }

    // create an array to store current positions of each slide
    slidePos = new Array(slides.length);

    // determine width of each slide
    width = container.getBoundingClientRect().width || container.offsetWidth;

    element.style.width = (slides.length * width) + 'px';

    // stack elements
    var pos = slides.length;

    if (bulletWrapper != null) {

      var bulletWrapperObj = container.querySelector(bulletWrapper);
      var bulletInc = 0;
      bulletWrapperObj.innerHTML = '';

    }

    while(pos--) {

      var slide = slides[pos];

      slide.style.width = width + 'px';
      slide.setAttribute('data-index', pos);

      if (clonedSlides === false || pos <= 1) {
        if (bulletWrapperObj) {
          bulletWrapperObj.innerHTML += '<a class="' + bulletClass + '" href="#">' + bulletInc + '</a>';
          bulletInc++;
        }
      }

      if (browser.transitions) {
        slide.style.left = (pos * -width) + 'px';
        move(pos, index > pos ? -width : (index < pos ? width : 0), 0);
      }

    }

    // reposition elements before and after index
    if (options.continuous && browser.transitions) {
      move(circle(index-1), -width, 0);
      move(circle(index+1), width, 0);
    }

    if (!browser.transitions) element.style.left = (index * -width) + 'px';

    container.style.visibility = 'visible';
    container.className = container.className + ' initialised';

    // Need to highlight the bullet assigned to the current slide
    // the setup function is called on window resize so we cant highlight the first bullet but the current index
    hightlightCurrentBullet(index);
  }

  function hightlightCurrentBullet(to){
    if (bulletWrapper){

      var bulletWrapperObj = container.querySelector(bulletWrapper);
      var childObj = bulletWrapperObj.childNodes;

      for (var i=0;i<childObj.length;i++) {
        removeClassFromElem(childObj[i], "active");
      }
      addClassToElem(childObj[to], "active");
    }
  }

  function prev() {

    if (options.continuous) slide(index-1);
    else if (index) slide(index-1);

  }

  function next() {

    if (options.continuous) slide(index+1);
    else if (index < slides.length - 1) slide(index+1);

  }

  function circle(index) {

    // a simple positive modulo using slides.length
    return (slides.length + (index % slides.length)) % slides.length;

  }

  function slide(to, slideSpeed) {

    // do nothing if already on requested slide
    if (index == to) return;

    if (browser.transitions) {

      var direction = Math.abs(index-to) / (index-to); // 1: backward, -1: forward

      // get the actual position of the slide
      if (options.continuous) {
        var natural_direction = direction;
        direction = -slidePos[circle(to)] / width;

        // if going forward but to < index, use to = slides.length + to
        // if going backward but to > index, use to = -slides.length + to
        if (direction !== natural_direction) to =  -direction * slides.length + to;

      }

      var diff = Math.abs(index-to) - 1;

      // move all the slides between index and to in the right direction
      while (diff--) move( circle((to > index ? to : index) - diff - 1), width * direction, 0);

      to = circle(to);

      move(index, width * direction, slideSpeed || speed);
      move(to, 0, slideSpeed || speed);

      if (options.continuous) move(circle(to - direction), -(width * direction), 0); // we need to get the next in place

    } else {

      to = circle(to);
      animate(index * -width, to * -width, slideSpeed || speed);
      //no fallback for a circular continuous if the browser does not accept transitions
    }

    index = to;

    position = clonedSlides ? (index % 2) : index;

    // Highlighting the current slide bullet
    hightlightCurrentBullet(position);

    offloadFn(options.callback && options.callback(position, slides[index]));
  }

  function move(index, dist, speed) {

    translate(index, dist, speed);
    slidePos[index] = dist;

  }

  function translate(index, dist, speed) {

    var slide = slides[index];
    var style = slide && slide.style;

    if (!style) return;

    style.webkitTransitionDuration =
      style.MozTransitionDuration =
        style.msTransitionDuration =
          style.OTransitionDuration =
            style.transitionDuration = speed + 'ms';

    style.webkitTransform = 'translate(' + dist + 'px,0)' + 'translateZ(0)';
    style.msTransform =
      style.MozTransform =
        style.OTransform = 'translateX(' + dist + 'px)';

  }

  function animate(from, to, speed) {

    // if not an animation, just reposition
    if (!speed) {

      element.style.left = to + 'px';
      return;

    }

    var start = +new Date;

    var timer = setInterval(function() {

      var timeElap = +new Date - start;

      if (timeElap > speed) {

        element.style.left = to + 'px';

        if (delay) begin();

        options.transitionEnd && options.transitionEnd.call(event, position, slides[index]);

        clearInterval(timer);
        return;

      }

      element.style.left = (( (to - from) * (Math.floor((timeElap / speed) * 100) / 100) ) + from) + 'px';

    }, 4);

  }

  // setup auto slideshow
  var delay = options.auto || 0;
  var interval;

  function begin() {

    interval = setTimeout(next, delay);

  }

  function stop() {

    delay = 0;
    clearTimeout(interval);

  }

  function restart() {
    stop();
    delay = options.auto || 0;
    begin();
  }

  // setup initial vars
  var start = {};
  var delta = {};
  var isScrolling;

  // setup event capturing
  var events = {

    handleEvent: function(event) {

      switch (event.type) {
        case 'touchstart': this.start(event); break;
        case 'touchmove': this.move(event); break;
        case 'touchend': offloadFn(this.end(event)); break;
        case 'webkitTransitionEnd':
        case 'msTransitionEnd':
        case 'oTransitionEnd':
        case 'otransitionend':
        case 'transitionend': offloadFn(this.transitionEnd(event)); break;
        case 'resize': offloadFn(setup); break;
      }

      if (options.stopPropagation) event.stopPropagation();

    },
    start: function(event) {

      var touches = event.touches[0];

      // measure start values
      start = {

        // get initial touch coords
        x: touches.pageX,
        y: touches.pageY,

        // store time to determine touch duration
        time: +new Date

      };

      // used for testing first move event
      isScrolling = undefined;

      // reset delta and end measurements
      delta = {};

      // attach touchmove and touchend listeners
      element.addEventListener('touchmove', this, false);
      element.addEventListener('touchend', this, false);

    },
    move: function(event) {

      // ensure swiping with one touch and not pinching
      if ( event.touches.length > 1 || event.scale && event.scale !== 1) return

      if (options.disableScroll) event.preventDefault();

      var touches = event.touches[0];

      // measure change in x and y
      delta = {
        x: touches.pageX - start.x,
        y: touches.pageY - start.y
      };

      // determine if scrolling test has run - one time test
      if ( typeof isScrolling === 'undefined') {
        isScrolling = !!( isScrolling || Math.abs(delta.x) < Math.abs(delta.y) );
      }

      // if user is not trying to scroll vertically
      if (!isScrolling) {

        // prevent native scrolling
        event.preventDefault();

        // stop slideshow
        stop();

        // increase resistance if first or last slide
        if (options.continuous) { // we don't add resistance at the end

          translate(circle(index-1), delta.x + slidePos[circle(index-1)], 0);
          translate(index, delta.x + slidePos[index], 0);
          translate(circle(index+1), delta.x + slidePos[circle(index+1)], 0);

        } else {

          delta.x =
            delta.x /
            ( (!index && delta.x > 0               // if first slide and sliding left
              || index == slides.length - 1        // or if last slide and sliding right
              && delta.x < 0                       // and if sliding at all
            ) ?
              ( Math.abs(delta.x) / width + 1 )      // determine resistance level
              : 1 );                                 // no resistance if false

          // translate 1:1
          translate(index-1, delta.x + slidePos[index-1], 0);
          translate(index, delta.x + slidePos[index], 0);
          translate(index+1, delta.x + slidePos[index+1], 0);
        }

      }

    },
    end: function(event) {

      // measure duration
      var duration = +new Date - start.time;

      // determine if slide attempt triggers next/prev slide
      var isValidSlide =
        Number(duration) < 250               // if slide duration is less than 250ms
        && Math.abs(delta.x) > 20            // and if slide amt is greater than 20px
        || Math.abs(delta.x) > width/2;      // or if slide amt is greater than half the width

      // determine if slide attempt is past start and end
      var isPastBounds =
        !index && delta.x > 0                            // if first slide and slide amt is greater than 0
        || index == slides.length - 1 && delta.x < 0;    // or if last slide and slide amt is less than 0

      if (options.continuous) isPastBounds = false;

      // determine direction of swipe (true:right, false:left)
      var direction = delta.x < 0;

      // if not scrolling vertically
      if (!isScrolling) {

        if (isValidSlide && !isPastBounds) {

          if (direction) {

            if (options.continuous) { // we need to get the next in this direction in place

              move(circle(index-1), -width, 0);
              move(circle(index+2), width, 0);

            } else {
              move(index-1, -width, 0);
            }

            move(index, slidePos[index]-width, speed);
            move(circle(index+1), slidePos[circle(index+1)]-width, speed);
            index = circle(index+1);

          } else {
            if (options.continuous) { // we need to get the next in this direction in place

              move(circle(index+1), width, 0);
              move(circle(index-2), -width, 0);

            } else {
              move(index+1, width, 0);
            }

            move(index, slidePos[index]+width, speed);
            move(circle(index-1), slidePos[circle(index-1)]+width, speed);
            index = circle(index-1);

          }

          position = clonedSlides ? (index % 2) : index;
          options.callback && options.callback(position, slides[index]);

        } else {

          if (options.continuous) {

            move(circle(index-1), -width, speed);
            move(index, 0, speed);
            move(circle(index+1), width, speed);

          } else {

            move(index-1, -width, speed);
            move(index, 0, speed);
            move(index+1, width, speed);
          }

        }

      }

      // kill touchmove and touchend event listeners until touchstart called again
      element.removeEventListener('touchmove', events, false)
      element.removeEventListener('touchend', events, false)

      // we need to highlight the bullet when we swipe the slide, not just on next or prev
      hightlightCurrentBullet(index);
    },
    transitionEnd: function(event) {

      if (parseInt(event.target.getAttribute('data-index'), 10) == index) {

        if (delay || options.autoRestart) restart();

        options.transitionEnd && options.transitionEnd.call(event, position, slides[index]);

      }

    }

  };

  // trigger setup
  setup();

  // start auto slideshow if applicable
  if (delay) begin();


  // add event listeners
  if (browser.addEventListener) {


    // We need to add the listeners on the prev and next buttons if the specific DOM ids were sent when the Swipe object was instantiated
    // We keep them separated because a user might want to add only one button (either next or prev)
    if (options.btnNextClass) {

      var nextButton = container.querySelector(options.btnNextClass);

      addEventHandler(nextButton,"click",function(e){
        e.preventDefault();
        offloadFn(stop.call());
        offloadFn(next.call());
      });

    }

    if (options.btnPrevClass) {

      var prevButton = container.querySelector(options.btnPrevClass);

      addEventHandler(prevButton,"click",function(e){
        e.preventDefault();
        offloadFn(stop.call());
        offloadFn(prev.call());
      });

    }

    if (options.bulletWrapperClass) {

      var bulletWrap = container.querySelector(options.bulletWrapperClass);

      addEventHandler(bulletWrap,"click",function(e){
        if (getTarget(e).innerHTML) {
          var slideNumber = parseInt(getTarget(e).innerHTML);
          if (!isNaN(slideNumber)) {
            e.preventDefault();
            offloadFn(stop.call());
            offloadFn(slide(slideNumber));
          }
        }
      });

    }


    // set touchstart event on element
    if (browser.touch) element.addEventListener('touchstart', events, false);

    if (browser.transitions) {
      element.addEventListener('webkitTransitionEnd', events, false);
      element.addEventListener('msTransitionEnd', events, false);
      element.addEventListener('oTransitionEnd', events, false);
      element.addEventListener('otransitionend', events, false);
      element.addEventListener('transitionend', events, false);
    }

    // set resize event on window
    window.addEventListener('resize', events, false);

  } else {

    window.onresize = function () { setup() }; // to play nice with old IE

  }

  // expose the Swipe API
  return {
    setup: function() {

      setup();

    },
    slide: function(to, speed) {

      // cancel slideshow
      stop();

      slide(to, speed);

    },
    prev: function() {

      // cancel slideshow
      stop();

      prev();

    },
    next: function() {

      // cancel slideshow
      stop();

      next();

    },
    restart: function() {

      // Restart slideshow
      restart();

    },
    stop: function() {

      // cancel slideshow
      stop();

    },
    getPos: function() {

      // return current index position
      return position;

    },
    getNumSlides: function() {

      // return total number of slides
      return length;
    },
    kill: function() {

      // cancel slideshow
      stop();

      // reset element
      element.style.width = '';
      element.style.left = '';

      // reset slides
      var pos = slides.length;
      while (pos--) {

        var slide = slides[pos];
        slide.style.width = '';
        slide.style.left = '';

        if (browser.transitions) translate(pos, 0, 0);

      }

      // removed event listeners
      if (browser.addEventListener) {

        // remove current event listeners
        element.removeEventListener('touchstart', events, false);
        element.removeEventListener('webkitTransitionEnd', events, false);
        element.removeEventListener('msTransitionEnd', events, false);
        element.removeEventListener('oTransitionEnd', events, false);
        element.removeEventListener('otransitionend', events, false);
        element.removeEventListener('transitionend', events, false);
        window.removeEventListener('resize', events, false);

      }
      else {

        window.onresize = null;

      }

    }
  }

}


if ( window.jQuery || window.Zepto ) {
  (function($) {
    $.fn.Swipe = function(params) {
      return this.each(function() {
        $(this).data('Swipe', new Swipe($(this)[0], params));
      });
    }
  })( window.jQuery || window.Zepto )
}

if(typeof module === "object" && typeof module.exports === "object") {
  module.exports = Swipe;
} else {
  window.Swipe = Swipe;
}

},{}],"/root/app-home/src/public/logged-out-mobile.js":[function(require,module,exports){
'use strict';

var _carouselBulletsNojq = require('module-tsl-ui-components/plugins/carousel-bullets/carousel-bullets-nojq');

var _carouselBulletsNojq2 = _interopRequireDefault(_carouselBulletsNojq);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _carouselBulletsNojq2.default)('.js-carousel-bullets', {
  auto: 0,
  autoRestart: false,
  bulletWrapperClass: 'js-carousel-bullets-nav',
  bulletClass: 'carousel-bullets__nav-bullet'
});

},{"module-tsl-ui-components/plugins/carousel-bullets/carousel-bullets-nojq":"/root/app-home/node_modules/module-tsl-ui-components/plugins/carousel-bullets/carousel-bullets-nojq.js"}]},{},["/root/app-home/src/public/logged-out-mobile.js"])
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
